<template>
  <main class="main">
    <div class="buttons">
      <router-link :to="{ name: 'produit-filtration-creation' }" custom v-slot="{ navigate }">
        <ButtonElement color="bordeaux" :icon="PhPlus" @click="navigate">
          Ajouter un produit de filtration
        </ButtonElement>
      </router-link>
    </div>
    <div class="cards" v-if="produits.length">
      <CardComponent
        v-for="produit in produits"
        :key="produit.id"
        :transparent="!produit.actif"
        :icon="PhFunnel"
        :title="`${produit.nom}${!produit.actif ? ' (supprimé)' : ''}`"
      >
        <template #buttons>
          <router-link
            :to="{ name: 'produit-filtration-modification', params: { id: produit.id } }"
            custom
            v-slot="{ navigate }"
          >
            <ButtonElement
              v-if="produit.actif"
              color="bordeaux"
              :icon="PhPen"
              size="small"
              @click="navigate"
              >Modifier</ButtonElement
            >
          </router-link>
          <ButtonElement
            color="danger"
            bordered
            :icon="produit.actif ? PhTrash : PhRecycle"
            :disabled="!cacheStore.online"
            size="small"
            label-class="tablet-only"
            @click="confirmDeleteProduit(produit)"
            >{{ produit.actif ? 'Supprimer' : 'Restaurer' }}</ButtonElement
          >
        </template>
        <CardInfoComponent title="Catégorie">{{
          produit.categorie_produit_filtration_nom
        }}</CardInfoComponent>
      </CardComponent>
    </div>
    <div class="message" v-else>
      <PhWarning />
      <span>Aucun produit de filtration n'est enregistré.</span>
    </div>
  </main>
  <ConfirmElement ref="confirmRef" @yes="deleteProduit" />
</template>

<script setup lang="ts">
import { PhFunnel, PhPen, PhPlus, PhRecycle, PhTrash, PhWarning } from '@phosphor-icons/vue'
import ButtonElement from '@/components/ButtonElement.vue'
import useFetch from '@/composables/useFetch.ts'
import { onMounted, ref, type Ref, useTemplateRef } from 'vue'
import { useLoadingStore } from '@/stores/loading.ts'
import ConfirmElement from '@/components/ConfirmElement.vue'
import CardComponent from '@/components/card/CardComponent.vue'
import CardInfoComponent from '@/components/card/CardInfoComponent.vue'
import type { ProduitFiltrationList } from '@/interfaces/ProduitFiltrationList.ts'
import { useCacheStore } from '@/stores/cache.ts'

// dépendances
const api = useFetch()

// stores
const cacheStore = useCacheStore()
const loadingStore = useLoadingStore()

const produits: Ref<ProduitFiltrationList[]> = ref([])

const confirmRef = useTemplateRef<typeof ConfirmElement>('confirmRef')

async function getProduits() {
  produits.value = await cacheStore.getProduits()
}

function confirmDeleteProduit(produit: ProduitFiltrationList) {
  confirmRef.value?.show(
    produit,
    `${produit.actif ? 'Suppression' : 'Restauration'} d\'un produit de filtration`,
    `Êtes-vous sûr de vouloir ${produit.actif ? 'supprimer' : 'restaurer'} le produit de filtration <b class="b">${produit.nom}</b> ?`,
  )
}

async function deleteProduit(produit: ProduitFiltrationList) {
  loadingStore.start()
  try {
    await api.delete(`produits-filtration/${produit.id}`)
    await getProduits()
  } finally {
    loadingStore.stop()
  }
}

onMounted(async () => {
  loadingStore.start()
  try {
    await getProduits()
  } finally {
    loadingStore.stop()
  }
})
</script>
